import { createInterpolatedTranslationKey, Translate } from '@dreryk/react-common';
import { ValidationErrorNotification } from '@dreryk/react-components';

import { DosageStageValidation, getQuantityMaxValue } from '~libs.shared.prescription';

import { prescriptionTranslationKeys } from '../../../../../../../translations';
import { DosageFrequencyNotAllowedMessage } from '../../../numericalDosage/DosageFrequencyNotAllowedMessage';

type StageFieldNotificationsProps = {
   readonly index: number;
   readonly validation: DosageStageValidation;
};

export const StageFieldNotifications = (props: StageFieldNotificationsProps): JSX.Element => {
   return (
      <>
         {props.validation.frequencyNotAllowed ? <DosageFrequencyNotAllowedMessage /> : null}
         {props.validation.durationNotMultipleOfIntervalAmount === undefined ? null : (
            <ValidationErrorNotification
               testId={`extendedDosageDurationNotMultipleOfInterval-${props.index}`}
               label={
                  <Translate>
                     {createInterpolatedTranslationKey(
                        prescriptionTranslationKeys.extendedDosage.durationNotMultipleOfInterval,
                        { intervalAmount: String(props.validation.durationNotMultipleOfIntervalAmount) }
                     )}
                  </Translate>
               }
            />
         )}
         {props.validation.exceededPackagesCount === undefined ? null : (
            <ValidationErrorNotification
               testId={`extendedDosagePackagesCountExceeded-${props.index}`}
               label={
                  <Translate>
                     {createInterpolatedTranslationKey(
                        prescriptionTranslationKeys.extendedDosage.packagesCountExceeded,
                        {
                           packagesCount: String(props.validation.exceededPackagesCount),
                           maxValue: String(getQuantityMaxValue()),
                        }
                     )}
                  </Translate>
               }
            />
         )}
      </>
   );
};
